import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CustomInputType, StatusCode, FactorTypes, MfaStatus } from 'src/app/_common/_enum/module.enum';
import { PRODUCT_CONFIG, FORM_MSGS, MFA_MSGS, MFA_FACTORS } from 'src/app/_common/product-config';
import { AuthenticationService } from 'src/app/user/_services/authentication.service';
import LogRocket from 'logrocket';
import { LoginService } from '../_services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/_services/common.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {

  private customInputTypes = CustomInputType; // Using it in HTML
  private factorTypes = FactorTypes; // Using it in HTML
  private mfaStatus = MfaStatus; // Using it in HTML
  private productConfig = PRODUCT_CONFIG; // Using it in HTML
  private formMsgs = FORM_MSGS; // Using it in HTML
  private mfaMsgs = MFA_MSGS; // Using it in HTML
  private mfaOptions = MFA_FACTORS; // Using it in HTML

  private user: any = [];

  private loading: boolean = false; // Using it in HTML
  private verifyingCode: boolean = false; // Using it in HTML
  private sendingPush: boolean = false; // Using it in HTML
  private pushSent: boolean = false; // Using it in HTML
  private updatingMfa: boolean = false;

  private showCodeSent: boolean = false;
  private showQRCode: boolean = false; // Using it in HTML
  private showSendPush: boolean = false;
  private showGoBackBtn: boolean = true; // Using it in HTML
  private enterOktaCode: boolean = false; 
  private textSelected: boolean = false; // Using it in HTML
  private sendNewClicked: boolean = false;
  private oktaTotpEntered: boolean = false;
  private backBtnClicked: boolean = false;
  private continueBtnClicked: boolean = false;

  private authenticationTitle: string = this.mfaMsgs.SetUpTitle; // Using it in HTML
  private authenticationLabel: string = this.mfaMsgs.SelectVerificationLabel; // Using it in HTML
  private codeSentDesc: string = this.mfaMsgs.TextSentDesc; // Using it in HTML

  private oktaFactorID: string = '';
  private factorType: string = '';
  private qrCodeLink: string = ''; // Using it in HTML
  private oktaTotpID: string = '';
  private returnUrl: string = '';
  private daysToExpire: number = 0;
  private daysToExpireStr: string = '';

  private factorArray: any = [];
  private enrollData: any;
  private mfaProfile: any;

  private errorMessage: string = ''; // Using it in HTML
  private successMessage: string = ''; // Using it in HTML

  private totpExpiration: any = null;
  private totpExpiresAt: Date;

  private noReturnUrl = ['error', 'login', 'nopermission'];

  @ViewChild("sessionTimeoutModal", {static: false}) sessionTimeoutModal;
  @ViewChild("updateConfirmationModal", {static: false}) updateConfirmationModal;
  @ViewChild("updatePasswordModal", {static: false}) updatePasswordModal;

  @ViewChild("mfaEnrollmentForm", {static: false}) mfaEnrollmentForm: NgForm;
  @ViewChild("codeSentForm", {static: false}) codeSentForm: NgForm;
  @ViewChild("pushSentForm", {static: false}) pushSentForm: NgForm;

  constructor(private authenticationService: AuthenticationService, private loginService: LoginService, private el: ElementRef, private router: Router, private modalService : NgbModal, private route: ActivatedRoute, private commonService: CommonService) { }

  ngOnInit() {
    this.user = this.authenticationService.currentUser;
    this.updatingMfa = (this.user && this.user.SID) ? true : false;
    if(this.user.mfaSkipped){
      this.antiForgeryToken();
    }
    else{
      this.setInitialSignIn();
    }
  }

  setInitialSignIn(){
    if(this.user && this.user.factors){ //set up MFA options
      let totpFactor = this.user.factors.find(factor => factor.factorType === this.factorTypes.totp);
      this.user.factors.forEach(factor => {
        this.mfaOptions.forEach(option =>{
          if(factor.factorType == option.type){ 
            option.status = factor.status;
            option.factorID = factor.id;
            if(option.type == this.factorTypes.push && totpFactor && totpFactor.userPreferred){
              option.isPreferred = totpFactor.userPreferred;
              option.isSelected = totpFactor.userPreferred;
            } else{
              option.isPreferred = factor.userPreferred;
              option.isSelected = factor.userPreferred;
            }
            this.factorArray.push(option); 
          }
        })
      });
    }
    if(!this.updatingMfa){ //set up initial sign in
      if(this.user && this.user.preferredFactor){
        this.factorType = this.user.preferredFactor.factorType;
        this.oktaFactorID = this.user.preferredFactor.id;
        this.showGoBackBtn = false;
        this.showCodeSent = (this.factorType == this.factorTypes.text || this.factorType == this.factorTypes.email) ? true : false;
        this.showSendPush = (this.factorType == this.factorTypes.push || this.factorType == this.factorTypes.totp) ? true : false;
        this.codeSentDesc = (this.factorType == this.factorTypes.email) ? this.mfaMsgs.EmailSentDesc : this.mfaMsgs.TextSentDesc;
        if(this.showSendPush && this.authenticationService.factorChallenged){ //push automatically sent through sign in
          this.pushSent = true;
          this.verifyPush(); 
        }
      } else {
        let factor = this.factorArray.find(factor => factor.type === this.factorTypes.text || factor.type === this.factorTypes.email);
        if(factor == null && !this.authenticationService.factorChallenged){ //internal user (Okta MFA only) not yet enrolled
          let pushFactor = this.factorArray.find(factor => factor.type === this.factorTypes.push);
          this.showGoBackBtn = false;
          this.factorType = pushFactor.type;
          this.oktaFactorID = pushFactor.factorID;
          this.enrollFactor(this.factorType, null);
        }
      }
    } else{ //set up update on user profile
      this.backToSetup();
      this.authenticationTitle = this.mfaMsgs.UpdateTitle;
      this.authenticationLabel = this.mfaMsgs.UpdateVerificationLabel; 
    }
  }

  backToSetup(){
    if(this.showCodeSent){ this.codeSentForm.reset(); }
    if(this.showSendPush && this.enterOktaCode){ this.pushSentForm.reset(); }
    this.textSelected = false;
    this.enterOktaCode = false;
    this.oktaTotpEntered = false;
    this.showCodeSent = false;
    this.showQRCode = false;
    this.showSendPush = false;
    this.pushSent = false;
    this.sendNewClicked = false;
    this.continueBtnClicked = false;
    this.verifyingCode = false;
    this.errorMessage = '';
    this.successMessage = '';
  }

  backToProfile(){
    this.loading = true;
    this.authenticationService.preferredFactor = null;
    let mfaProfileSubscription = this.authenticationService.mfaProfile().subscribe(mfaData =>{
      this.mfaProfile = mfaData;
      this.mfaProfile.forEach(factor => {
        this.mfaOptions.forEach(option =>{
          if(factor.userPreferred && factor.factorType == option.type){ this.authenticationService.preferredFactor = option; }
        })
      });
      this.loading = false;
      this.authenticationService.authenticationScreen = false;
      this.authenticationService.header.pageTitle = "User Profile";
    },
    error => {
      this.loading = false;
      console.log('Error Occured!!! ');
    });
    this.authenticationService.runningServices.push(mfaProfileSubscription);
  }

  checkEnrollmentStatus(factorType){
    if(this.user && this.user.preferredFactor && (this.user.preferredFactor.factorType == factorType || this.user.optionalFactor.factorType == factorType)){
      return true;
    } else{
      let factor = this.factorArray.find(factor => factor.type === factorType && (factor.status === this.mfaStatus.active || factor.status === this.mfaStatus.enrolling));
      if(factor || (this.enrollData && this.enrollData.factorType == factorType && (this.enrollData.status == this.mfaStatus.active || this.enrollData.status == this.mfaStatus.enrolling))) { 
        let status = (factor) ? factor.status : this.enrollData.status;
        if(status == this.mfaStatus.enrolling){ this.sendNewClicked = true; }
        this.oktaFactorID = (factor) ? factor.factorID : this.enrollData.factorID;
        this.factorType = (factor) ? factor.type : this.enrollData.factorType;
        return true; 
      } else { return false; }
    }
  }

  collapseOptions(type){
    this.factorArray.forEach(factor =>{
      if(type != factor.type){ factor.isSelected = false; }
    });
  }

  enrollFactor(factorType, phone){
    this.backBtnClicked = false;
    this.codeSentDesc = (factorType == this.factorTypes.email) ? this.mfaMsgs.EmailSentDesc : this.mfaMsgs.TextSentDesc;
    if(!this.sendNewClicked){
      const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
      if(formGroupInvalid.length>0 && factorType == this.factorTypes.text){
        this.textSelected = true;
        (<HTMLInputElement>formGroupInvalid[0]).focus();
        return;
      }
    }
    if(!this.updatingMfa){ //enrollment prior to login
      this.loading = true;
      if(!this.checkEnrollmentStatus(factorType)){ //factor not yet active
        let requestPayload = { "userID": this.user.UID, "sessionToken": this.user.oktaSessionToken, "stateToken": this.user.oktaStateToken, "factorType": factorType, "provider": "OKTA", "phoneNumber": phone };
        let enrollMFASubscription = this.authenticationService.enrollMFA(requestPayload).subscribe((data)=>{
          this.enrollData = data.body.result;
          this.continueEnrollment();
        }, error=>{
          this.loading = false; 
          if(error.status == StatusCode.AuthenticationFailed && error.error && error.error.result && error.error.result.status && (error.error.result.status == this.mfaMsgs.OktaTryAgainText || error.error.result.status == this.mfaMsgs.OktaTryAgainEmail)){ 
            this.showCodeSent = true;
            this.errorMessage = this.mfaMsgs.OktaTryAgainMsg; //wait 30 sec to resend
          } 
          else{ this.loginService.openModal('error', ''); }
        });
        this.authenticationService.runningServices.push(enrollMFASubscription);
      } else {  //factor is already active
        if(factorType == this.factorTypes.text || factorType == this.factorTypes.email){
          this.sendChallenge();
          this.showCodeSent = true; 
        }else if(factorType == this.factorTypes.push || factorType == this.factorTypes.totp){
          this.showSendPush = true;
          if(this.authenticationService.factorChallenged){ this.verifyPush(); }
          this.loading = false;
        }
      }
    }else{  //enrollment post login on update
      this.factorType = factorType;
      this.modalService.open(this.updateConfirmationModal, { centered: true, backdropClass: 'light-blue-backdrop' });
    }
  }

  updateEnrollment(factorType, phone){
    this.loading = true;
    //enrollment post login on update
    let requestPayload = { "userID": this.user.UID, "factorType": factorType, "provider": "OKTA", "phoneNumber": phone };
      let updateMfaSubscription = this.authenticationService.updateMfa(requestPayload).subscribe((data)=>{
        this.enrollData = data.body.result;
        this.continueEnrollment();
      }, error=>{
        this.loading = false; 
        if(error.status == StatusCode.AuthenticationFailed && error.error && error.error.result && error.error.result.status && (error.error.result.status == this.mfaMsgs.OktaTryAgainText || error.error.result.status == this.mfaMsgs.OktaTryAgainEmail)){
          this.showCodeSent = true;
          this.errorMessage = this.mfaMsgs.OktaTryAgainMsg; //wait 30 sec to resend
        } else{
          this.loginService.openModal('error', '');
        }
      });
      this.authenticationService.runningServices.push(updateMfaSubscription);
  }

  continueEnrollment(){
    this.oktaFactorID = this.enrollData.oktaFactorID;
    this.factorType = this.enrollData.factorType;
    this.qrCodeLink = this.enrollData.qrCodeLink;
    let selectedFactor = this.factorArray.find(factor => factor.type === this.factorType);
    selectedFactor.status = this.enrollData.status;
    selectedFactor.factorID = this.oktaFactorID;
    if(this.factorType == this.factorTypes.text || this.factorType == this.factorTypes.email){
      if(this.enrollData.challengeSent){ 
        this.showCodeSent = true;  
        this.loading = false;
        if(this.sendNewClicked){ this.successMessage = this.mfaMsgs.CodeSentSuccess; }
        if(this.updatingMfa){
          //check for TOTP expiration
          let currentTime = new Date();
          this.totpExpiresAt = new Date(currentTime.getTime() + 300000); //current time + 5 minutes 
          this.totpExpiration = setInterval(()=>{
            this.checkTotpExpiration();
          }, 1000);
        }
      } else if(!this.updatingMfa || (this.updatingMfa && this.factorType == this.factorTypes.text)) { this.sendChallenge(); } 
    } else if(this.enrollData.qrCodeLink && (this.factorType == this.factorTypes.push || this.factorType == this.factorTypes.totp)){
      this.showQRCode = true;
      this.enrollPush();
      this.loading = false;
    }
  }

  enrollPush(){
    //polling until QR code is scanned
    let requestPayload = { "userID": this.user.UID, "sessionToken": this.user.oktaSessionToken, "stateToken": this.user.oktaStateToken, "oktaFactorID": this.oktaFactorID };
    let enrollPushSubscription = this.authenticationService.enrollOktaVerify(requestPayload).subscribe((data)=>{
      if(data.enrolled){ //QR Code scanned
        console.log("Okta Verify Enrolled!!!");
        LogRocket.log("Okta Verify Enrolled!!!");
        this.loading = true;
        this.showQRCode = false;
        this.showSendPush = true;
        this.oktaTotpID = data.oktaTOTPFactorID;
        this.user = this.authenticationService.currentUser;
        let pushFactor = this.factorArray.find(factor => factor.type === this.factorTypes.push);
        pushFactor.status = this.mfaStatus.active;
      } else if(data.expired && !data.waiting){ //QR code expired
        if(this.updatingMfa){ this.backToProfile(); }
        else{ this.clearStorage(); }
        console.log("QR Code Expired!");
        LogRocket.log("QR Code Expired!");
      }
      this.loading = false;
    }, error=>{
      this.loading = false; 
      this.loginService.openModal('error', '');
    });
    this.authenticationService.runningServices.push(enrollPushSubscription);
  }

  sendPush(){
    this.pushSent = false;
    this.sendingPush = true;
    this.oktaTotpEntered = false;
    if(this.factorType == this.factorTypes.totp && this.user.optionalFactor){
      this.oktaFactorID = this.user.optionalFactor.id;
      this.factorType = this.user.optionalFactor.factorType;
    }
    if(!this.updatingMfa){ //send push prior to login
      let requestPayload = { "userID": this.user.UID, "oktaFactorID": this.oktaFactorID, "stateToken": this.user.oktaStateToken, "sessionToken": this.user.oktaSessionToken };
      let sendPushSubscription = this.authenticationService.sendPush(requestPayload).subscribe((pushData)=>{
        this.user = this.authenticationService.currentUser;
        if(pushData.body.result.factorChallenged){
          console.log("Okta Verify push sent!");
          this.sendingPush = false;
          this.pushSent = true;
          this.verifyPush();
        }
      }, error=>{
        this.sendingPush = false; 
        this.loginService.openModal('error', '');
      });
      this.authenticationService.runningServices.push(sendPushSubscription);
    } else { //send push post login on update
      let updateSendPushSubscription = this.authenticationService.updateSendPush(this.oktaFactorID).subscribe((updateData)=>{
        this.user = this.authenticationService.currentUser;
        if(updateData.body.result.factorChallenged){
          console.log("Okta Verify push sent!");
          this.sendingPush = false;
          this.pushSent = true;
          this.verifyPush();
        }
      }, error=>{
        this.sendingPush = false; 
      });
      this.authenticationService.runningServices.push(updateSendPushSubscription);
    }
  }

  verifyPush(){
    if(!this.updatingMfa){ //verify push prior to login
      let pollingPayload = { "userID": this.user.UID, "oktaFactorID": this.oktaFactorID, "oktaTransactionCode": this.user.oktaTransactionCode, "stateToken": this.user.oktaStateToken, "sessionToken": this.user.oktaSessionToken };
      let challengeOktaVerifySubscription = this.authenticationService.challengeOktaVerify(pollingPayload).subscribe((verifyData)=>{
        if(verifyData.factorRejected){
          console.log("Okta Verify push was rejected!!!");
          this.clearStorage(); //bring user back to login page
        } else if(verifyData.factorVerified){
          console.log("Okta Verify push was verified!!!");
          this.authenticationService.factorVerified = true;
          this.antiForgeryToken(); // get antiforgery token
          //this.loginUser(); //get permissions and login user
        }
      }, error=>{
        this.loginService.openModal('error', '');
      });
      this.authenticationService.runningServices.push(challengeOktaVerifySubscription);
    } else{ //verify push post login on update
      let updateVerifyPushSubscription = this.authenticationService.updateVerifyPush(this.oktaFactorID, this.user.oktaTransactionCode).subscribe((updateData)=>{
        if(updateData.factorRejected){
          console.log("Okta Verify push was rejected!!!");
          this.backToProfile();
        } else if(updateData.factorVerified){
          console.log("Okta Verify push was verified!!!");
          this.authenticationService.factorVerified = true;
          this.backToProfile();
        }
      }, error=>{ });
      this.authenticationService.runningServices.push(updateVerifyPushSubscription);
    }
  }

  sendChallenge(){
    this.loading = true;
    this.errorMessage = '';
    this.successMessage = '';
    //resend TOTP enrollment status = active
    if(this.checkEnrollmentStatus(this.factorType)){
      let requestPayload = { "userID": this.user.UID, "oktaFactorID": this.oktaFactorID, "sessionToken": this.user.oktaSessionToken, "stateToken": this.user.oktaStateToken, "resend": this.sendNewClicked };
      let sendChallengeSubscription = this.authenticationService.sendChallenge(requestPayload).subscribe((data)=>{
        this.loading = false;
        if(data.body.result.factorChallenged){
          this.showCodeSent = true; 
          if(this.sendNewClicked){ this.successMessage = this.mfaMsgs.CodeSentSuccess; }
          if(this.updatingMfa){
            //check for TOTP expiration
            let currentTime = new Date();
            this.totpExpiresAt = new Date(currentTime.getTime() + 300000); //current time + 5 minutes 
            this.totpExpiration = setInterval(()=>{
              this.checkTotpExpiration();
            }, 1000);
          }
        } else if(data.body.result.message == this.mfaMsgs.OktaTryAgainEmail || data.body.result.message == this.mfaMsgs.OktaTryAgainText) { 
          this.showCodeSent = true;
          this.errorMessage = this.mfaMsgs.OktaTryAgainMsg; 
        } //wait 30 sec to resend
        this.loading = false; 
      }, error=>{
        this.loading = false; 
        this.loginService.openModal('error', '');
      });
      this.authenticationService.runningServices.push(sendChallengeSubscription);
    } else if(this.updatingMfa){ //resend TOTP on update enrollment status = pending
      this.updateEnrollment(this.factorType, this.user.mfaPhone);
    } else { //resend TOTP enrollment status = pending
      this.enrollFactor(this.factorType, this.user.mfaPhone);
    }
  }

  checkTotpExpiration(){
    //once user's totp has been verified, back button clicked, or user navigated away: stop checking for timeout
    if(this.authenticationService.factorVerified || this.backBtnClicked || !this.router.url.includes('/profile') || !this.authenticationService.authenticationScreen){
      clearInterval(this.totpExpiration);
      if(this.authenticationService.hasOpenModals()){ this.authenticationService.closeModal(); }
    }else{ //get the current time and calculate expiration warning time
      let currentTime = new Date();
      let warning = new Date(this.totpExpiresAt.getTime() - 60000);
      if(currentTime.toString() == warning.toString()){
        console.log("TOTP will expire in 1 minute");
        LogRocket.log("TOTP will expire in 1 minute");
        this.modalService.open(this.sessionTimeoutModal, { centered: false, backdropClass: 'light-blue-backdrop' });
      } else if(currentTime.toString() == this.totpExpiresAt.toString()){
        console.log("TOTP has expired");
        LogRocket.log("TOTP has expired");
        clearInterval(this.totpExpiration);
        this.ngOnDestroy();
        if(this.authenticationService.hasOpenModals()){ this.authenticationService.closeModal(); }
        this.backToProfile(); //send user back to profile page
      }
    }
  }

  verifyChallenge(code){
    this.continueBtnClicked = true;
    const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
    if(formGroupInvalid.length>0){
      (<HTMLInputElement>formGroupInvalid[0]).focus();
      return;
    }
    this.verifyingCode = true;
    this.ngOnDestroy();
    this.errorMessage = '';
    if(this.oktaTotpEntered){ 
      if(this.factorType == this.factorTypes.push && this.user.optionalFactor){
        this.oktaFactorID = this.user.optionalFactor.id;
        this.factorType = this.user.optionalFactor.factorType;
      } else {
        if(this.oktaTotpID){ this.oktaFactorID = this.oktaTotpID; } 
        else if(this.factorArray && this.factorArray.length > 0){ this.oktaFactorID = this.factorArray.find(factor => factor.type === this.factorTypes.totp).factorID; }
      }
    } 
    if(!this.updatingMfa){ //verify enrollment prior to login
      let requestPayload = { "passCode": code, "userID": this.user.UID, "oktaFactorID": this.oktaFactorID, "sessionToken": this.user.oktaSessionToken, "stateToken": this.user.oktaStateToken };
      let verifyChallengeSubscription = this.authenticationService.verifyChallenge(requestPayload).subscribe((data)=>{
        if(data.body.result.sessionID){
          this.antiForgeryToken(); // get antiforgery token
          //this.loginUser(); //get permissions and login user
          this.authenticationService.factorVerified = true;
        }
      }, error=>{
        this.verifyingCode = false;
        if(error.status == StatusCode.AuthenticationFailed && error.error && error.error.errorContent && error.error.errorContent.message == this.mfaMsgs.InvalidTOTP){ this.errorMessage = this.mfaMsgs.MfaInvalidTotp; }
        else{ this.loginService.openModal('error', ''); }
      });
      this.authenticationService.runningServices.push(verifyChallengeSubscription);
    } else{ // verify enrollment post login on update
      let requestPayload = { "passCode": code, "oktaFactorID": this.oktaFactorID };
      let verifyChallengeSubscription = this.authenticationService.updateVerifyMfa(requestPayload).subscribe((data)=>{
        if(data.body.result.factorVerified){
          this.backToProfile();
          this.authenticationService.factorVerified = true;
        }
      }, error=>{
        this.verifyingCode = false;
        if(error.status == StatusCode.AuthenticationFailed && error.error && error.error.errorContent && error.error.errorContent.message == this.mfaMsgs.InvalidTOTP){ this.errorMessage = this.mfaMsgs.MfaInvalidTotp; }
        else{ this.loginService.openModal('error', ''); }
      });
      this.authenticationService.runningServices.push(verifyChallengeSubscription);
    }
  }
  antiForgeryToken() {
    this.loading = true;
    this.authenticationService.antiForgery().subscribe(_token => {
      this.loginUser();
    },
      error => {
        this.commonService.removeData();
        this.commonService.removeLocalStorageData();
        this.router.navigateByUrl('/logout');
    })
  }
  loginUser(){
    this.loading = true;
    let authorizeSubscription = this.authenticationService.authorize(this.authenticationService.currentUser).subscribe(user=>{
      this.loading = false;
      let currentUser = this.authenticationService.currentUser;
      this.authenticationService.setUserLoggedIn(true);
      if(this.authenticationService.hasOpenModals()){ this.authenticationService.closeModal(); }
      this.route.queryParams.subscribe(params => {
        this.returnUrl = params['returnUrl'];
      });
      if (this.returnUrl && this.noReturnUrl.findIndex(_returnUrl=> this.returnUrl.includes(_returnUrl)) < 0) {
        this.router.navigateByUrl(this.returnUrl);
      }else{
        this.router.navigateByUrl('/dashboard');
      }
      if(!this.commonService.isProSightUser && currentUser.passwordExpirationDate){ //show password expiration warning
        let currentDate = new Date();
        let expiration = new Date(currentUser.passwordExpirationDate);
        this.daysToExpire = Math.round((expiration.getTime() - currentDate.getTime()) / (1000*60*60*24));
        if(this.daysToExpire <= this.productConfig.DaysUntilPasswordExpiration){ 
          this.daysToExpireStr = this.daysToExpire + " day";
          if(this.daysToExpire > 1){ this.daysToExpireStr = this.daysToExpireStr + "s"; } 
          this.modalService.open(this.updatePasswordModal, { centered: true, backdropClass: 'light-blue-backdrop' }); 
        }
      }
    }, error=>{
      this.loading = false;
      this.authenticationService.logout().subscribe(data => {
        this.authenticationService.authenticationScreen = false;
        if(error && error.error && error.error.errorContent && error.error.errorContent.message.toLowerCase() == "no user found"){
          this.errorMessage = this.formMsgs.ValidUsernamePassword; // Enter a valid username and password to continue.
        }else{
          this.loginService.openModal('error', '');
        }
      });
    });

    this.authenticationService.runningServices.push(authorizeSubscription);
  }

  updatePassword(){
    this.router.navigateByUrl('/profile');
  }

  clearStorage(){
    this.authenticationService.removeData();
    this.authenticationService.authenticationScreen = false;
  }

  ngOnDestroy() {
    this.authenticationService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
